import { render, staticRenderFns } from "./ProductStateHistory.vue?vue&type=template&id=15ae96a5&"
import script from "./ProductStateHistory.vue?vue&type=script&lang=js&"
export * from "./ProductStateHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports